export const ROUTES = {
  rpCalculator: '/rp-calculator',
  notFound: '/404',
  login: '/login',
};

export const RP_CALCULATOR_WIDTH = 440;
export const RP_CALCULATOR_HEIGHT = 888;
